 
 
 
 
 
 
define(['./localeService'], function(LocaleService) {
    'use strict';
    return new LocaleService();
});



// WEBPACK FOOTER //
// ./config/language/globalLocaleService.js